import { $Qll, $Q } from "../utils/query-selector"
import { priceVat } from "./price-vat";

const handleBadge = (value) => {
  const badge = $Q('.main-product__detail .product-disponibility .badge[data-quantity]')
  if (!badge) return

  const data = JSON.parse(badge.dataset.quantity.replaceAll("'", '"'))
  const quantity = data.quantity - Number(value)
  const badgeClass = quantity < 0 ? data.class_sale : data.class_instock
  const badgeText = quantity < 0 ? data.msg_sale : data.msg_instock
  badge.className = `badge ${badgeClass}`
  badge.textContent = badgeText;
}

function renderHTPrice(value, parent) {
  if (window.cfCurrencySwitcher) return;
  const quantitys = $Qll(".ht", parent);
  
  quantitys.forEach((element) => {
    const formattedPrice = parseFloat(element.dataset.price.replace(",", "."));
    const newPrice = formattedPrice * value
    element.innerText = `${newPrice.toFixed(2).replace(".", ",")}€`;
  });
}

export const multiplyQuantity = (parent, value) => {
  const vatContainer = $Q(".price-product-js", parent)
  
  renderHTPrice(value, parent)
  
  priceVat(value, vatContainer)

  handleBadge(value)
}
